import d from "clsx";
import * as R from "react";
import t, { forwardRef as l, useState as K, useRef as z } from "react";
import { useFloating as Z, offset as P, arrow as U, size as J, autoUpdate as Q, useClick as V, useDismiss as Y, useRole as ee, useMergeRefs as te, useInteractions as se, FloatingArrow as ne } from "@floating-ui/react";
const ie = "_icon_1i7w6_1", ae = "_xs_1i7w6_12", oe = "_sm_1i7w6_16", re = "_base_1i7w6_20", le = "_lg_1i7w6_24", ce = "_xl_1i7w6_28", _e = "_x1_1i7w6_32", de = "_x2_1i7w6_36", me = "_x3_1i7w6_40", ge = "_x4_1i7w6_44", j = {
  icon: ie,
  xs: ae,
  sm: oe,
  base: re,
  lg: le,
  xl: ce,
  x1: _e,
  x2: de,
  x3: me,
  x4: ge
}, x = l(
  ({ icon: n, label: e, size: s = "base", className: i, ...a }, r) => {
    const o = n;
    return /* @__PURE__ */ t.createElement(
      o,
      {
        "aria-hidden": e ? void 0 : !0,
        "aria-label": e,
        className: d(j.icon, j[s], i),
        ref: r,
        role: e ? "img" : void 0,
        ...a
      }
    );
  }
);
x.displayName = "Icon";
const pe = "_button_1j8jb_1", ue = "_small_1j8jb_19", ve = "_inline_1j8jb_25", fe = "_fullWidth_1j8jb_29", ke = "_primary_1j8jb_34", we = "_secondary_1j8jb_64", be = "_tertiary_1j8jb_91", ye = "_iconRight_1j8jb_143", u = {
  button: pe,
  small: ue,
  inline: ve,
  fullWidth: fe,
  primary: ke,
  secondary: we,
  tertiary: be,
  "brand-promotion": "_brand-promotion_1j8jb_121",
  iconRight: ye
}, Ee = "button", he = l(
  ({
    as: n,
    className: e,
    children: s,
    variant: i = "primary",
    size: a = "normal",
    fullWidth: r,
    icon: o,
    iconPosition: m = "left",
    ...c
  }, g) => {
    const p = n ?? Ee;
    return /* @__PURE__ */ t.createElement(
      p,
      {
        type: p === "button" ? "button" : void 0,
        ...c,
        className: d(
          u.button,
          u[i],
          {
            [u.small]: a === "small",
            [u.iconRight]: o && m === "right",
            [u.inline]: !r,
            [u.fullWidth]: r
          },
          e
        ),
        ref: g
      },
      o ? /* @__PURE__ */ t.createElement(x, { icon: o }) : null,
      s
    );
  }
);
he.displayName = "Button";
const xe = "_card_wl4rl_1", Ne = "_padded_wl4rl_8", Ce = "_flush_wl4rl_20", Re = "_condensed_wl4rl_36", f = {
  card: xe,
  padded: Ne,
  "card-group": "_card-group_wl4rl_12",
  flush: Ce,
  condensed: Re
}, ze = "div", je = l(
  ({
    as: n,
    className: e,
    children: s,
    padded: i = !1,
    ...a
  }, r) => {
    const o = n ?? ze;
    return /* @__PURE__ */ t.createElement(
      o,
      {
        ...a,
        className: d(
          f.card,
          { [f.padded]: i },
          e
        ),
        ref: r
      },
      s
    );
  }
);
je.displayName = "Card";
const De = "div", $e = l(
  ({
    as: n,
    className: e,
    children: s,
    condensed: i = !1,
    flushOnMobile: a = !1,
    padded: r = !1,
    ...o
  }, m) => {
    const c = n ?? De;
    return /* @__PURE__ */ t.createElement(
      c,
      {
        ...o,
        className: d(
          f["card-group"],
          {
            [f.flush]: a,
            [f.condensed]: i,
            [f.padded]: r
          },
          e
        ),
        ref: m
      },
      s
    );
  }
);
$e.displayName = "CardGroup";
const Ae = "_timeline_ckebo_1", v = {
  timeline: Ae,
  "timeline-list-item": "_timeline-list-item_ckebo_7",
  "timeline-node-line": "_timeline-node-line_ckebo_11",
  "timeline-node": "_timeline-node_ckebo_11",
  "timeline-node-period": "_timeline-node-period_ckebo_24",
  "timeline-child-container": "_timeline-child-container_ckebo_39"
}, Le = l(
  ({ className: n, children: e, ...s }, i) => /* @__PURE__ */ t.createElement("ol", { className: d(v.timeline, n), ref: i, ...s }, e)
);
Le.displayName = "Timeline";
const Me = l(
  ({ children: n, ...e }, s) => /* @__PURE__ */ t.createElement("li", { className: v["timeline-list-item"], ref: s, ...e }, /* @__PURE__ */ t.createElement("div", { className: v["timeline-node"] }, /* @__PURE__ */ t.createElement("span", { className: v["timeline-node-period"] }), /* @__PURE__ */ t.createElement("span", { className: v["timeline-node-line"] })), /* @__PURE__ */ t.createElement("div", { className: v["timeline-child-container"] }, n))
);
Me.displayName = "TimelineItem";
const Te = "_tag_1x9g6_1", We = "_notification_1x9g6_11", D = {
  tag: Te,
  notification: We
}, Ie = l(
  ({ variant: n = "notification", className: e, children: s, ...i }, a) => /* @__PURE__ */ t.createElement(
    "strong",
    {
      className: d(D.tag, D[n], e),
      ref: a,
      ...i
    },
    s
  )
);
Ie.displayName = "Tag";
const h = {
  XXS: 4,
  XS: 8,
  SM: 12,
  MD: 16,
  LG: 24,
  XL: 32,
  XXL: 40
}, Oe = "_dropdown_1uo4h_1", Be = "_title_1uo4h_13", Xe = "_body_1uo4h_26", Se = "_padded_1uo4h_32", b = {
  dropdown: Oe,
  title: Be,
  body: Xe,
  padded: Se
}, $ = 14, A = 1, Fe = l(
  ({
    children: n,
    triggerEl: e,
    title: s,
    padded: i = !1,
    verticalOffset: a = "XS",
    dropdownRole: r = "dialog",
    ...o
  }, m) => {
    const [c, g] = K(!1), p = z(null), y = z(), { refs: N, strategy: L, x: M, y: T, context: w } = Z({
      open: c,
      onOpenChange: g,
      placement: "bottom-start",
      strategy: "absolute",
      middleware: [
        P({
          mainAxis: h[a]
        }),
        U({
          element: p
        }),
        J({
          padding: h.MD,
          apply({ availableWidth: k, elements: E, middlewareData: C }) {
            if (Object.assign(E.floating.style, {
              width: `${k}px`,
              maxHeight: `${window.innerHeight - E.reference.getBoundingClientRect().bottom - (C.offset?.y ?? 0) - h.MD}px`
            }), C.arrow && p.current && y.current) {
              const { left: H } = E.reference.getBoundingClientRect(), { left: q, width: G } = y.current.getBoundingClientRect();
              Object.assign(p.current.style, {
                left: q - H - ($ / 2 + A) + G / 2
              });
            }
          }
        })
      ],
      whileElementsMounted: Q
    }), W = V(w), I = Y(w), O = ee(w, { role: r }), B = te([N.setFloating, ...m ? [m] : []]), { getFloatingProps: X, getReferenceProps: S } = se([
      W,
      I,
      O
    ]), F = (k) => {
      k.key === "Enter" && g(!1);
    };
    return /* @__PURE__ */ t.createElement(t.Fragment, null, e({ refs: N, getReferenceProps: S, arrowRef: y, isOpen: c }), c ? /* @__PURE__ */ t.createElement(
      "div",
      {
        ...o,
        className: b.dropdown,
        ref: B,
        style: {
          position: L,
          top: T ?? 0,
          left: M ?? 0
        },
        ...X()
      },
      s ? /* @__PURE__ */ t.createElement(
        "span",
        {
          className: d(b.title),
          onClick: () => g(!1),
          onKeyDown: (k) => F(k),
          role: "button",
          tabIndex: 0
        },
        s
      ) : null,
      /* @__PURE__ */ t.createElement(
        "div",
        {
          className: d(b.body, { [b.padded]: i })
        },
        n
      ),
      /* @__PURE__ */ t.createElement(
        ne,
        {
          context: w,
          fill: "#ECECEC",
          ref: p,
          stroke: "#999",
          strokeWidth: A,
          width: $
        }
      )
    ) : null);
  }
);
Fe.displayName = "Dropdown";
const He = l(function(e, s) {
  return /* @__PURE__ */ R.createElement(
    "svg",
    {
      fill: "none",
      ref: s,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      ...e
    },
    /* @__PURE__ */ R.createElement(
      "path",
      {
        clipRule: "evenodd",
        d: "M18.245 18.0385H5.75495C4.98009 18.0385 4.49963 17.1953 4.89465 16.5287L11.1397 5.9902C11.527 5.3366 12.4729 5.3366 12.8602 5.9902L19.1053 16.5287C19.5003 17.1953 19.0198 18.0385 18.245 18.0385ZM11.2874 9.28764C11.2671 8.88013 11.592 8.53857 12 8.53857C12.408 8.53857 12.7329 8.88013 12.7125 9.28764L12.525 13.0392C12.511 13.3189 12.2801 13.5386 12 13.5386C11.7199 13.5386 11.489 13.3189 11.475 13.0392L11.2874 9.28764ZM12 16.0386C12.425 16.0386 12.75 15.7136 12.75 15.2885C12.75 14.9761 12.5 14.5386 12 14.5386C11.575 14.5386 11.25 14.8761 11.25 15.2885C11.25 15.7136 11.5875 16.0386 12 16.0386Z",
        fill: "currentColor",
        fillRule: "evenodd"
      }
    )
  );
}), qe = "_alert_1k9kz_1", Ge = "_square_1k9kz_8", Ke = "_aggressive_1k9kz_61", _ = {
  alert: qe,
  square: Ge,
  "passive-success": "_passive-success_1k9kz_12",
  "passive-information": "_passive-information_1k9kz_17",
  "passive-warning": "_passive-warning_1k9kz_22",
  "passive-destructive": "_passive-destructive_1k9kz_27",
  "passive-brand-update": "_passive-brand-update_1k9kz_32",
  "passive-aggressive": "_passive-aggressive_1k9kz_37",
  "passive-aggressive-success": "_passive-aggressive-success_1k9kz_41",
  "passive-aggressive-information": "_passive-aggressive-information_1k9kz_45",
  "passive-aggressive-warning": "_passive-aggressive-warning_1k9kz_49",
  "passive-aggressive-destructive": "_passive-aggressive-destructive_1k9kz_53",
  "passive-aggressive-brand-update": "_passive-aggressive-brand-update_1k9kz_57",
  aggressive: Ke,
  "alert-description": "_alert-description_1k9kz_64",
  "aggressive-success": "_aggressive-success_1k9kz_68",
  "aggressive-information": "_aggressive-information_1k9kz_72",
  "aggressive-warning": "_aggressive-warning_1k9kz_76",
  "aggressive-destructive": "_aggressive-destructive_1k9kz_80",
  "aggressive-brand-update": "_aggressive-brand-update_1k9kz_84",
  "alert-icon": "_alert-icon_1k9kz_88",
  "alert-text": "_alert-text_1k9kz_92",
  "alert-title": "_alert-title_1k9kz_96"
}, Ze = "div", Pe = [
  "warning",
  "destructive",
  "brand-update"
], Ue = (n) => Pe.includes(n), Je = l(
  ({
    as: n,
    title: e,
    variant: s = "passive",
    level: i,
    square: a,
    className: r,
    children: o,
    ...m
  }, c) => {
    const g = n ?? Ze;
    return /* @__PURE__ */ t.createElement(
      g,
      {
        "aria-label": e,
        "aria-live": Ue(i) ? "assertive" : "polite",
        className: d(
          _.alert,
          a ? _.square : void 0,
          _[s],
          _[`${s}-${i}`],
          s === "passive-aggressive" ? _[`passive-${i}`] : void 0,
          r
        ),
        ref: c,
        role: "alert",
        ...m
      },
      /* @__PURE__ */ t.createElement(x, { className: _["alert-icon"], icon: He, size: "lg" }),
      /* @__PURE__ */ t.createElement("div", { className: _["alert-text"] }, e ? /* @__PURE__ */ t.createElement("h2", { className: _["alert-title"] }, e) : null, /* @__PURE__ */ t.createElement("span", { className: _["alert-description"] }, o))
    );
  }
);
Je.displayName = "Alert";
export {
  Je as Alert,
  he as Button,
  je as Card,
  $e as CardGroup,
  Fe as Dropdown,
  x as Icon,
  Ie as Tag,
  Le as Timeline,
  Me as TimelineItem
};
